import React from "react";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../auth/hooks/useProfile";
import WelcomeBackDots from "../../../components/ui/icons/WelcomeBackDots";
import ProgressRing from "../../../components/ui/icons/ProgressRing";

interface WelcomeBackProps {
  percent?: number;
}

const WelcomeBack: React.FC<WelcomeBackProps> = ({ percent = 0 }) => {
  const navigate = useNavigate();
  const { user } = useProfile();
  const remaining = 100 - percent;

  return (
    <div
      className="relative overflow-hidden rounded-[10px]"
      style={{
        padding: "24px 30px",
        backgroundColor: "#fff",
        backgroundImage:
          "linear-gradient(314deg, rgba(0,103,255,0.2) 0%, #ffffff 60%)",
        boxShadow: "0 2px 14px rgba(0,0,0,0.10)",
      }}
    >
      <div
        className="absolute pointer-events-none"
        style={{
          bottom: 18,
          right: 10,
          width: "100%",
          maxWidth: 603,
          zIndex: 0,
        }}
      >
        <WelcomeBackDots />
      </div>

      <div className="relative z-10 flex flex-col tablet:flex-row tablet:items-center gap-6">
        <div className="flex flex-col items-start flex-1">
          <p
            className="font-semibold text-dark-blue mb-2"
            style={{ fontSize: 16, fontFamily: "var(--font-primary)" }}
          >
            Team Trust Accelerator Survey
          </p>
          <div
            style={{
              width: 40,
              height: 3,
              background: "#3b519c",
              borderRadius: 2,
              marginBottom: 20,
            }}
          />
          <h2
            className="font-bold text-dark-blue mb-3"
            style={{
              fontSize: "clamp(22px, 3vw, 30px)",
              fontFamily: "var(--font-primary)",
              lineHeight: 1.2,
            }}
          >
            Welcome Back, {user?.first_name}
          </h2>
          <p
            className="text-dark-blue mb-1"
            style={{ fontSize: 14, fontFamily: "var(--font-primary)" }}
          >
            Your Progress
          </p>
          <p
            style={{
              fontSize: 13,
              color: "#7d86a9",
              fontFamily: "var(--font-primary)",
            }}
          >
            {percent}% Accomplished |{" "}
            <span className="font-semibold text-dark-blue">
              {remaining}% Remaining
            </span>
          </p>

          <button
            onClick={() => navigate("/survey")}
            className="btn btn-normal btn-md mt-6 hidden tablet:block"
          >
            Continue
          </button>
        </div>

        <div className="w-full tablet:w-auto flex justify-center flex-shrink-0">
          <div className="w-[220px] tablet:w-[266px]">
            <ProgressRing percent={percent} />
          </div>
        </div>
      </div>

      <div className="relative z-10 tablet:hidden mt-4 flex justify-center">
        <button
          onClick={() => navigate("/survey")}
          className="btn btn-normal btn-md max-w-[280px]"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default WelcomeBack;
